export default __webpack_public_path__ + "images/ac3bee0f9e291419f4739296b0ff9c3f-environment.webp";